import { Button } from 'antd';
import { CloseOutlined } from '@ant-design/icons';
import { FormattedMessage } from 'react-intl';

export const deleteColumnCommand = ({ editor, range }) =>
  range ? editor.chain().focus().deleteRange(range).deleteColumn().run() : editor.chain().focus().deleteColumn().run();

const DeleteColumn = ({ editor, showLabel = false, isExtension = false }) => {
  return (
    <Button
      className={`editor-toolbar-btn-container !bg-transparent`}
      icon={<CloseOutlined className="text-gray-800 text-xs" />}
      onClick={isExtension ? () => {} : () => deleteColumnCommand({ editor })}
      size="small"
      type="text"
    >
      {showLabel && (
        <div className="editor-toolbar-btn-label">
          <FormattedMessage id="TABLE_DELETE_COL" defaultMessage="Delete column" />
        </div>
      )}
    </Button>
  );
};

export default DeleteColumn;
